import { render, staticRenderFns } from "./SuggestPart.vue?vue&type=template&id=264ca216"
import script from "./SuggestPart.ts?vue&type=script&lang=ts&external"
export * from "./SuggestPart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports